import { service } from '@maia/insurance';
import { QueryOptions, queryOptions } from '@tanstack/react-query';

export type Insurances = Awaited<ReturnType<(typeof service)['getInsurances']>>;

export function getInsurancesOptions(
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Insurances>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['insurances', [search]],
    queryFn: async () => await service.getInsurances(search),
    initialData,
  });
}
